<template>
  <div class="aroma-sleep-stage-chart">
    <div
      v-if="series"
      ref="chart"
      class="aroma-sleep-stage-chart__canvas"
      role="img"
      aria-label="睡眠分期图"
    ></div>
    <van-empty v-else description="暂无睡眠分期数据" image-size="72"></van-empty>
  </div>
</template>

<script>
import * as echarts from 'echarts'

const stageNames = ['深睡眠期', '中睡眠期', '浅睡眠期', '清醒']

export default {
  name: 'AromaSleepStageChart',

  props: {
    series: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      chartInstance: null
    }
  },

  watch: {
    series: {
      deep: true,
      handler () {
        this.$nextTick(this.renderChart)
      }
    }
  },

  mounted () {
    this.renderChart()
    window.addEventListener('resize', this.resizeChart)
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.resizeChart)
    this.disposeChart()
  },

  methods: {
    chartOption () {
      const labels = this.series ? this.series.labels : []
      const lastLabelIndex = labels.length - 1
      const labelStep = Math.max(1, Math.ceil(labels.length / 8))
      return {
        animationDuration: 240,
        color: ['#2779ff'],
        grid: { left: 8, right: 18, top: 18, bottom: 24, containLabel: true },
        tooltip: {
          trigger: 'axis',
          confine: true,
          formatter: params => {
            const item = params[0]
            return item
              ? `${this.series.times[item.dataIndex] || '--'}<br/>睡眠阶段：${item.value}`
              : ''
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: labels,
          axisLine: { lineStyle: { color: '#dce8f2' } },
          axisTick: { show: false },
          axisLabel: {
            color: '#8f959e',
            fontSize: 10,
            hideOverlap: true,
            margin: 10,
            showMinLabel: true,
            showMaxLabel: true,
            interval: index => index === 0 || index === lastLabelIndex || index % labelStep === 0
          }
        },
        yAxis: {
          type: 'category',
          data: stageNames,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { color: '#8f959e', fontSize: 10 },
          splitLine: { show: true, lineStyle: { color: '#edf0f5' } }
        },
        series: [
          {
            name: '睡眠阶段',
            type: 'line',
            step: 'end',
            showSymbol: false,
            lineStyle: { width: 2 },
            data: this.series ? this.series.stages : []
          }
        ]
      }
    },

    disposeChart () {
      if (this.chartInstance) this.chartInstance.dispose()
      this.chartInstance = null
    },

    renderChart () {
      this.disposeChart()
      if (!this.series || !this.$refs.chart) return
      this.chartInstance = echarts.init(this.$refs.chart)
      this.chartInstance.setOption(this.chartOption())
    },

    resizeChart () {
      if (this.chartInstance) this.chartInstance.resize()
    }
  }
}
</script>

<style scoped lang="scss">
.aroma-sleep-stage-chart {
  overflow: hidden;
  border: 1px solid #dce8f2;
  border-radius: 8px;
  background: #f8fcff;

  &__canvas {
    width: 100%;
    height: 240px;
  }
}
</style>
